var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTriangleUpIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.00036 10.4072C7.18893 10.4072 6.00379 10.2849 5.0975 10.1729C4.40379 10.0884 3.96265 9.39237 4.23808 8.75123C4.90436 7.2038 5.93522 5.76837 7.4895 4.80837C7.643 4.71347 7.8199 4.6632 8.00036 4.6632C8.18083 4.6632 8.35772 4.71347 8.51122 4.80837C10.0655 5.76837 11.0964 7.2038 11.7626 8.75123C12.0381 9.39237 11.5969 10.0884 10.9044 10.1729C9.99693 10.2838 8.81179 10.4072 8.00036 10.4072Z",
    fill: "#828282",
    stroke: "#828282",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTriangleUpIcon);
export default __webpack_public_path__ + "static/media/triangle-up-icon.aaf7c8045354a273283f38a7ef3c9a34.svg";
export { ForwardRef as ReactComponent };